import { SwitchWithLabel } from 'components/shared/Switch/Switch';
import { useAppSelector } from 'hooks/useAppSelector';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { FormIdProps } from 'shared/props';
import { missedDealFeedbackPriceEnhancedChanged } from 'state/missed-deal-feeedback/actions';
import { getFeedbackIsPriceEnhanced } from 'state/missed-deal-feeedback/selectors';

import { FeedbackPriceEnhancementController } from './feedback-price-enhancement-controller';

export function PriceEnhanced({ formId }: FormIdProps) {
  const { formatMessage } = useIntl();
  const isPriceEnhanced = useAppSelector(state => getFeedbackIsPriceEnhanced(state, formId));
  const dispatch = useDispatch();

  return (
    <>
      <SwitchWithLabel
        id="missedDealFeedback-priceEnhanced"
        value={isPriceEnhanced}
        onToggleSwitch={isEnhanced => dispatch(missedDealFeedbackPriceEnhancedChanged(formId, isEnhanced))}
        label={formatMessage({ id: 'missedDealFeedback.priceEnhanced' })}
        colSize={10}
        isAlignedLeft
        wrapText
      />
      {isPriceEnhanced && <FeedbackPriceEnhancementController formId={formId} />}
    </>
  );
}
